import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { StateType } from "../../../utils/types";
import { selectPositions } from "../../../redux/educator/selector";
import { getPositionUser } from "../../../redux/educator/actions";
import { setCurrentStep } from "../../../redux/shared/actions";

const mapStateToProps = (state: StateType) => ({
  positions: selectPositions(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getPositionUser,
      setCurrentStep,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
